"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogout = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _hooks = require("../../checkout/hooks");

var _context = require("../context");

var _utility = require("../utility");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useLogout = function useLogout() {
  var queryClient = (0, _reactQuery.useQueryClient)();

  var context = _react["default"].useContext(_context.AuthContext);

  var setOrder = (0, _hooks.useOrder)().setOrder;
  /* istanbul ignore next */

  if (!context) {
    throw new Error('useLogout must be used within an AuthProvider');
  }

  var dispatch = context.dispatch;

  var logout = function logout() {
    dispatch({
      type: _context.AuthActions.LOGOUT
    });
    (0, _utility.removeToken)();
    queryClient.clear();
    setOrder({
      paymentInfo: undefined,
      paymentToken: undefined
    });
    Sentry.setUser({
      id: undefined
    });
  };

  return [logout];
};

exports.useLogout = useLogout;